import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { Modal, Input, Button, } from "antd";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import 'ag-grid-enterprise';
import cal from '../assets/calendar.png';
import { DeleteOutlined, DownloadOutlined, ExclamationCircleOutlined, LogoutOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Card, Typography } from "antd";
import { ExclamationCircleFilled, CheckCircleFilled } from "@ant-design/icons";
import "./TmcDataTable.scss"; 
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { Spin } from "antd";




const pmOptions = ['Satvir', 'Kashik', 'Ryan', 'Ankita', 'Anul', 'Asha', 'Reema', 'Jackson', 'Jayan', 'Manish', 'Nithini', 'Shilpa', 'Suzzane', 'Branch', 'No Value'];



const TMCTable = () => {
  const { tmcName } = useParams();
  const clientTypeOptions = ['PROSPECT', 'DEMO DONE', 'PARTNERSHIP', 'LOST', 'DIRECT', `LOST By ${tmcName}`];
  // Change pmOptionsState initialization to only use pmOptions
  const [pmOptionsState, setPmOptionsState] = useState([...pmOptions]);

  // Add debounce mechanism to prevent multiple API calls
  const updateTimeoutRef = useRef(null);
  const pendingUpdatesRef = useRef(new Set());


  const [isAddPmModalOpen, setIsAddPmModalOpen] = useState(false);
  const [newPmData, setNewPmData] = useState({
    name: "",
    email: "",
    contact: "",
    tmc: tmcName
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);


  const [isAddRowModalOpen, setIsAddRowModalOpen] = useState(false);
  const [newRowData, setNewRowData] = useState({
    "Workspace_Active11": "",
    "Workspace-Trade_Name": "",
    "Ticket_Number Count": "",
    "Total K3": "",
    "Commercial": "",
    "Closing Date": "",
    "Contact": "",
    "Next Step": "",
    "PM Email ID": "",
    "PM Name": ""
  });




  const { Title, Text } = Typography;

  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalValue, setModalValue] = useState("");
  const [editingRow, setEditingRow] = useState(null);
  const [selectedClientType, setSelectedClientType] = useState(null);

  const gridRef = useRef();

  const gridApiRef = useRef(null);


  const handleSearch = (e) => {
    const api = gridApiRef.current;
    const value = e.target.value;

    if (api && typeof api.setGridOption === 'function') {
      api.setGridOption('quickFilterText', value);
    } else {
      console.warn("Grid API not ready or missing setGridOption:", api);
    }
  };


  const handleExport = () => {
    const api = gridApiRef.current;
    if (api) {
      api.exportDataAsCsv({ fileName: `${tmcName}-data.csv` });
    }
  };

  const reloadTable = () => {
    window.location.reload(); // or re-run fetch logic
  };


  const renderDropdownIcon = (params) => {
    const value = params.value?.trim();
    const displayText = value ? value : "Select";

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'space-around' }}>
        <span>{displayText}</span>
        <span style={{ fontSize: '12px', color: '#999' }}>▼</span>
      </div>
    );
  };


  const renderClientType = (params) => {
    const value = params.value;
    const styleMap = {
      'PROSPECT': { bg: '#E0F2FE', color: '#0369A1' },
      'Demo Done': { bg: '#DCFCE7', color: '#15803D' },
      'Partnership': { bg: '#FEF9C3', color: '#92400E' },
      'Lost': { bg: '#FEE2E2', color: '#B91C1C' },
      'Direct': { bg: '#F3E8FF', color: '#7E22CE' },
    };
    const dynamicLostKey = `LOST By ${tmcName}`;
    const style = styleMap[value] || (value === dynamicLostKey ? { bg: '#F3E8FF', color: '#B91C1C' } : { bg: '#f1f5f9', color: '#374151' });
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'space-between' }}>
        <span
          style={{
            backgroundColor: style.bg,
            color: style.color,
            padding: '1px 10px',
            height: '30px',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out'
          }}
        >
          {value}
        </span>
        <span style={{ fontSize: '10px', color: '#aaa' }}>▼</span>
      </div>
    );
  };


  const renderEditIconText = (params) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', maxWidth: '100%' }}>
      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, maxWidth: '180px', display: 'inline-block' }}>{params.value}</span>
      <span style={{ fontSize: '12px', color: '#aaa', marginTop: '10px' }}><svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
        <path d="M6.77051 5.83343H5.93717C5.49515 5.83343 5.07122 6.00903 4.75866 6.32159C4.4461 6.63415 4.27051 7.05807 4.27051 7.5001V15.0001C4.27051 15.4421 4.4461 15.8661 4.75866 16.1786C5.07122 16.4912 5.49515 16.6668 5.93717 16.6668H13.4372C13.8792 16.6668 14.3031 16.4912 14.6157 16.1786C14.9282 15.8661 15.1038 15.4421 15.1038 15.0001V14.1668M14.2705 4.16677L16.7705 6.66677M17.9247 5.48759C18.2529 5.15938 18.4373 4.71424 18.4373 4.25009C18.4373 3.78594 18.2529 3.34079 17.9247 3.01259C17.5965 2.68438 17.1513 2.5 16.6872 2.5C16.223 2.5 15.7779 2.68438 15.4497 3.01259L8.43717 10.0001V12.5001H10.9372L17.9247 5.48759Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
      </svg></span>
    </div>
  );

  const renderCalendarIcon = (params) => {
    const val = params.value;
    let display = '';
    let showIcon = true;

    try {
      if (val) {
        const date = new Date(val);
        if (!isNaN(date)) {
          const year = date.getFullYear(); // ✅ Use local time
          const month = String(date.getMonth() + 1).padStart(2, '0'); // ✅ Local month
          const day = String(date.getDate()).padStart(2, '0'); // ✅ Local day
          display = `${year}-${month}-${day}`;
          showIcon = false;
        } else {
          display = val;
        }
      }
    } catch (err) {
      console.error('Invalid date value:', val);
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span>{display}</span>
        {showIcon && <span style={{ fontSize: '14px' }}><img src={cal} alt="Calendar" height={20} /></span>}
      </div>
    );
  };

  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("bcd_token");
    localStorage.removeItem("bcd_email");
    window.location.href = "/login";
  };


  const handleCellValueChanged = useCallback(async (params) => {
    const updatedField = params.colDef.field;
    const oldValue = params.oldValue;
    let updatedValue = params.newValue;
    const rowNode = params.node;
    const updatedRow = rowNode.data;

    // Create a unique key for this update
    const updateKey = `${updatedRow._id}-${updatedField}`;

    // Check if this update is already pending
    if (pendingUpdatesRef.current.has(updateKey)) {
      console.log(`🔄 Update already pending for ${updateKey}, skipping...`);
      return;
    }

    // Add to pending updates
    pendingUpdatesRef.current.add(updateKey);

    // Clear existing timeout
    if (updateTimeoutRef.current) {
      clearTimeout(updateTimeoutRef.current);
    }

    // Set new timeout for debounced update
    updateTimeoutRef.current = setTimeout(async () => {
      try {
        // Recalculate revenue if Commercial % changed
        if (updatedField === 'Commercial' && updatedRow['Total K3']) {
          const percent = parseFloat(updatedValue.replace('%', '')) || 0;
          const k3 = parseFloat(updatedRow['Total K3']) || 0;
          updatedRow['Potential Revenue'] = ((percent * k3) / 100).toFixed(2);
        }

        console.log(`🔄 Updating ${updatedField} for row ${updatedRow._id}`);

        // 🔄 Update value
        await fetch("https://bcd-prospect-admin.finkraftai.com/api/update-tmc-details", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: updatedRow._id,
            source: tmcName,
            updatedBy: localStorage.getItem("bcd_email"),
            field: updatedField,
            value: updatedValue
          })
        });

        // 📌 Identify the row name dynamically
        const rowIdentifier =
          updatedRow["Workspace-Trade_Name"] ||
          updatedRow["Workspace"] ||
          updatedRow["Client Name"] ||
          updatedRow["PM Name"] ||
          Object.entries(updatedRow).find(
            ([key, val]) =>
              key.toLowerCase().includes("name") &&
              typeof val === "string" &&
              val.trim() !== ""
          )?.[1] ||
          updatedRow["_id"] || "Unknown";

        // 📝 Log the change
        await fetch("https://bcd-prospect-admin.finkraftai.com/api/log-tmc-change", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            row: rowIdentifier,
            column: updatedField,
            oldValue: oldValue,
            newValue: updatedValue,
            updatedBy: localStorage.getItem("bcd_email"),
            timestamp: new Date().toISOString()
          })
        });

        rowNode.setData({ ...updatedRow });
        console.log(`✅ Successfully updated ${updatedField} for row ${updatedRow._id}`);
      } catch (error) {
        console.error("Update or logging failed", error);
      } finally {
        // Remove from pending updates
        pendingUpdatesRef.current.delete(updateKey);
      }
    }, 300); // 300ms debounce delay
  }, [tmcName]);


  const handleNextStepEdit = (params) => {
    setEditingRow(params.node);
    setModalValue(params.value || "");
    setIsModalOpen(true);
  };

  const handleModalSave = async () => {
    if (editingRow) {
      const data = editingRow.data;
      data['Next Step'] = modalValue;
      await handleCellValueChanged({ node: editingRow, newValue: modalValue, colDef: { field: 'Next Step' } });
    }
    setIsModalOpen(false);
    setEditingRow(null);
  };

  const [loading, setLoading] = useState(false);


  useEffect(() => {
  (async () => {
    try {
      setLoading(true);

      // 1️⃣ Fetch Account Managers
      const res = await fetch(`https://bcd-prospect-admin.finkraftai.com/api/account-managers`);
      const managers = await res.json();

      const combinedNames = [
        ...managers.map(m => m.name)
      ];

      const fetchedPMNames = [...new Set(
        combinedNames.filter(name => name && typeof name === "string" && name.trim() !== "")
      )];

      const finalPmOptions = [...fetchedPMNames, '+ Add New Account Manager...'];
      setPmOptionsState(finalPmOptions);

      // 2️⃣ Fetch TMC Data
      const tmcRes = await fetch("https://bcd-prospect-admin.finkraftai.com/api/tmc-full-details", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const data = await tmcRes.json();

      const cleanedData = data.map((item) => {
        const { _id, SOURCE, ...rest } = item;
        const commercialValue = parseFloat((rest["Commercial"] || "0").replace("%", ""));
        const k3Value = parseFloat(rest["Total K3"] || 0);
        return {
          _id,
          source: SOURCE,
          ...rest,
          "Potential Revenue": ((commercialValue * k3Value) / 100).toFixed(2),
        };
      });

      const updatedColumnDefs = [
        {
          headerName: "Acount Manager Details",
          children: [
            {
              headerName: "Account Manager Name",
              field: "PM Name",
              editable: true,
              cellEditor: 'agSelectCellEditor',
              cellEditorParams: params => ({
                values: ['', ...finalPmOptions],
                cellEditorPopup: true,
                value: params.value || ''
              }),
              onCellValueChanged: (params) => {
                const value = params.newValue;
                if (value === '+ Add New Account Manager...') {
                  setIsAddPmModalOpen(true);
                  params.node.setDataValue("PM Name", '');
                  return;
                }
                params.newValue = value;
                params.node.setDataValue("PM Name", value);
                handleCellValueChanged(params);
              },
              cellRenderer: renderDropdownIcon,
              floatingFilter: true,
              filter: 'agSetColumnFilter',
            },
            {
              headerName: "Acount Manager Email ID",
              field: "PM Email ID",
              columnGroupShow: 'open',
              editable: true,
              floatingFilter: true,
              filter: 'agTextColumnFilter'
            },
            {
              field: "Contact",
              columnGroupShow: 'open',
              editable: true,
              floatingFilter: true,
              filter: 'agTextColumnFilter'
            },
          ]
        },
        {
          field: "Workspace_Active11",
          headerName: "Client Type",
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: { values: clientTypeOptions },
          cellRenderer: renderClientType,
          filter: "agSetColumnFilter",
          floatingFilter: true
        },
        {
          field: "Workspace-Trade_Name",
          headerName: "Workspace",
          editable: true,
          filter: 'agTextColumnFilter',
          floatingFilter: true,
          cellStyle: {
            whiteSpace: 'normal',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4px',
            lineHeight: '1.2',
          },
        },
        {
          field: "Closing Date",
          headerName: "Closing Date",
          editable: true,
          cellEditor: 'agDateCellEditor',
          cellEditorParams: {
            useBrowserDatePicker: true
          },
          valueFormatter: (params) => {
            if (!params.value) return '';
            const date = new Date(params.value);
            return date.toISOString().split('T')[0];
          },
          valueParser: (params) => {
            if (!params.newValue) return null;
            const [y, m, d] = params.newValue.split('-').map(Number);
            return new Date(Date.UTC(y, m - 1, d)).toISOString();
          },
          cellRenderer: renderCalendarIcon,
          filter: 'agDateColumnFilter',
          floatingFilter: true
        },
        {
          field: "Next Step",
          headerName: "Next Step",
          editable: false,
          cellRenderer: renderEditIconText,
          onCellClicked: handleNextStepEdit,
          filter: 'agTextColumnFilter',
          floatingFilter: true
        },
        {
          headerName: "Summary",
          headerClass: "summary-group-header",
          children: [
            {
              field: "Ticket_Number Count",
              headerName: "Transaction",
              headerClass: "summary-child-header",
              filter: 'agNumberColumnFilter',
              floatingFilter: true,
              cellClass: "summary-cell",
            },
            {
              field: "Total K3",
              headerName: "K3",
              cellClass: "summary-cell",
              headerClass: "summary-child-header",
              filter: 'agNumberColumnFilter',
              floatingFilter: true
            },
            {
              field: "Commercial",
              headerName: "Commercial %",
              editable: true,
              cellClass: "summary-cell",
              headerClass: "summary-child-header",
              filter: 'agNumberColumnFilter',
              floatingFilter: true
            },
            {
              field: "Potential Revenue",
              headerName: "Potential Revenue",
              filter: 'agNumberColumnFilter',
              headerClass: "summary-child-header",
              cellClass: "summary-cell",
              floatingFilter: true
            },
          ]
        },
        {
          field: "source",
          headerName: "Source",
          filter: 'agTextColumnFilter',
          floatingFilter: true
        },
        {
          field: "Last activity",
          headerName: "Last Activity",
          filter: 'agTextColumnFilter',
          floatingFilter: true,
          valueFormatter: (params) => {
            if (!params.value) return '';

            try {
              const date = new Date(params.value);
              if (isNaN(date.getTime())) return params.value || '';

              const pad = (n) => String(n).padStart(2, '0');
              const hours24 = date.getHours();
              const hours12 = hours24 % 12 || 12;
              const minutes = pad(date.getMinutes());
              const ampm = hours24 >= 12 ? 'PM' : 'AM';

              return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(hours12)}:${minutes} ${ampm}`;
            } catch (error) {
              console.warn('Invalid date value in Last Activity:', params.value);
              return params.value || '';
            }
          }
        },
        {
          field: "Update by",
          headerName: "Updated By",
          filter: 'agTextColumnFilter',
          floatingFilter: true
        },
        {
          field: "action",
          headerName: "Action",
          cellRenderer: (params) => {
            return (
              <Button
                type="primary"
                danger
                size="small"
                className="delete-btn"
                onClick={() => {
                  setRowToDelete(params);
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </Button>
            );
          },
          filter: false,
          editable: false,
          sortable: false,
          width: 100,
        }
      ];

      setColumnDefs(updatedColumnDefs);
      setRowData(cleanedData);

    } catch (err) {
      console.error("Error in loading data:", err);
    } finally {
      setLoading(false);
    }
  })();
}, [tmcName]);








  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
    };
  }, []);






  const getClientTypeMetrics = (type) => {
    const filtered = rowData.filter(row => row["Workspace_Active11"] === type);

    const count = filtered.length;

    const totalRevenue = filtered.reduce((sum, row) => {
      const revenue = parseFloat(row["Potential Revenue"] || 0);
      return sum + revenue;
    }, 0);

    return {
      count,
      revenue: totalRevenue.toFixed(2),
    };
  };


  const prospectMetrics = getClientTypeMetrics("PROSPECT");
  const demoDoneMetrics = getClientTypeMetrics("DEMO DONE");
  const lostMetrics = getClientTypeMetrics("LOST");
  const partnershipMetrics = getClientTypeMetrics("PARTNERSHIP");
  const directMetrics = getClientTypeMetrics("DIRECT");
  // const lostByBcdMetrics = getClientTypeMetrics(`LOST By ${tmcName}`);

  const renderCardItem = (amount, label, count, className = "") => {
    const isSelected = selectedClientType === label;

    return (
      <div
        className={`card-item ${isSelected ? 'selected-client-type' : ''} ${className}`}
        onClick={(e) => {
          e.stopPropagation();
          handleClientTypeClick(label);
        }}
      >
        <div className="card-item-row">
          <div className="card-text">
            <Text className="amount">₹{amount}</Text>
            <div className="label">
              {label} <span className="count">({count})</span>
            </div>
          </div>
          <span className="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5.6126 16.8932L7.02681 18.3074L15.5121 9.82211V17.6003H17.5203V6.39971H6.31971V8.4079H14.0979L5.6126 16.8932Z" fill="#777777" />
          </svg></span>
        </div>
      </div>
    );
  };






  const [selectedGroup, setSelectedGroup] = useState(null);


  const handleCardGroupClick = (group) => {
    console.log("🔍 Clicked card group:", group);

    const api = gridApiRef.current;
    if (!api) {
      console.log("❌ Grid API not ready");
      return;
    }

    const isSameGroup = selectedGroup === group;

    if (isSameGroup) {
      console.log("🟡 Same group clicked again. Clearing filter.");
      setSelectedGroup(null);
      setSelectedClientType(null); // <-- 👈 ADD THIS

      api.getFilterInstance("Workspace_Active11", (filterInstance) => {
        if (filterInstance) {
          console.log("🧼 Clearing filter model");
          filterInstance.setModel(null);
          api.onFilterChanged();
        } else {
          console.log("❌ Filter instance not found for 'Workspace_Active11'");
        }
      });
      return;
    }

    setSelectedGroup(group);
    setSelectedClientType(null); // <-- 👈 ADD THIS

    const clientTypes =
      group === "action"
        ? ["PROSPECT", "Demo Done", "Lost"]
        : ["Partnership", "Direct", `LOST By ${tmcName}`];

    console.log("✅ Applying filter for values:", clientTypes);

    api.getFilterInstance("Workspace_Active11", (filterInstance) => {
      if (filterInstance) {
        console.log("🎯 Filter instance found. Setting model.");
        filterInstance.setModel({ values: clientTypes });
        api.onFilterChanged();
      } else {
        console.log("❌ Filter instance not found for 'Workspace_Active11'");
      }
    });
  };


  const handleClientTypeClick = (clientType) => {
    const api = gridApiRef.current;
    if (!api) return;

    if (selectedClientType === clientType) {
      // Clear filter
      setSelectedClientType(null);
      api.getFilterInstance("Workspace_Active11", (filterInstance) => {
        if (filterInstance) {
          filterInstance.setModel(null);
          api.onFilterChanged();
        }
      });
      return;
    }

    // Apply new filter
    setSelectedClientType(clientType);
    setSelectedGroup(null); // clear group filter
    api.getFilterInstance("Workspace_Active11", (filterInstance) => {
      if (filterInstance) {
        filterInstance.setModel({ values: [clientType] });
        api.onFilterChanged();
      }
    });
  };







  return (
    <div style={{ padding: "0 0" }} className="detailed-data-page">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <h2 style={{ marginBottom: "10px" }}>{tmcName}TMCs Detailed Data</h2>
        <Button danger icon={<LogoutOutlined />} onClick={() => setShowLogoutPopup(true)}>Logout</Button>
      </div>
      <div className="card-section">
        <Card
          className={`card-box action-required ${selectedGroup === 'action' ? 'selected-card' : ''}`}
          bordered
          onClick={() => handleCardGroupClick('action')}
        >

          <div className="card-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M11.0825 2.62329L18.2775 15.085C18.3872 15.275 18.445 15.4905 18.445 15.7099C18.445 15.9294 18.3872 16.1449 18.2775 16.3349C18.1678 16.525 18.01 16.6828 17.82 16.7925C17.63 16.9022 17.4144 16.96 17.195 16.96H2.80501C2.58559 16.96 2.37004 16.9022 2.18002 16.7925C1.99 16.6828 1.83221 16.525 1.7225 16.3349C1.61279 16.1449 1.55504 15.9294 1.55504 15.7099C1.55504 15.4905 1.6128 15.275 1.72251 15.085L8.91751 2.62329C9.39834 1.78996 10.6008 1.78996 11.0825 2.62329ZM10 12.5C9.77899 12.5 9.56703 12.5878 9.41075 12.744C9.25447 12.9003 9.16667 13.1123 9.16667 13.3333C9.16667 13.5543 9.25447 13.7663 9.41075 13.9225C9.56703 14.0788 9.77899 14.1666 10 14.1666C10.221 14.1666 10.433 14.0788 10.5893 13.9225C10.7455 13.7663 10.8333 13.5543 10.8333 13.3333C10.8333 13.1123 10.7455 12.9003 10.5893 12.744C10.433 12.5878 10.221 12.5 10 12.5ZM10 6.66662C9.7959 6.66665 9.59889 6.74159 9.44636 6.87722C9.29383 7.01285 9.19639 7.19975 9.17251 7.40246L9.16667 7.49996V10.8333C9.16691 11.0457 9.24824 11.25 9.39405 11.4044C9.53985 11.5589 9.73913 11.6518 9.95117 11.6643C10.1632 11.6767 10.372 11.6077 10.5349 11.4714C10.6977 11.3351 10.8024 11.1417 10.8275 10.9308L10.8333 10.8333V7.49996C10.8333 7.27894 10.7455 7.06698 10.5893 6.9107C10.433 6.75442 10.221 6.66662 10 6.66662Z" fill="#E7000B" />
            </svg>
            <Title level={5} className="title">Action Required</Title>
          </div>
          <div className="card-content">
            {renderCardItem(prospectMetrics.revenue, "Prospect", prospectMetrics.count)}
            {renderCardItem(demoDoneMetrics.revenue, "Demo Done", demoDoneMetrics.count)}
            {renderCardItem(lostMetrics.revenue, "Lost", lostMetrics.count)}
          </div>
        </Card>

        <Card
          className={`card-box good-standing ${selectedGroup === 'good' ? 'selected-card' : ''}`}
          bordered
          onClick={() => handleCardGroupClick('good')}
        >

          <div className="card-header">
            <CheckCircleFilled />
            <Title level={5} className="title">Good Standing</Title>
          </div>
          <div className="card-content">
            {renderCardItem(partnershipMetrics.revenue, "Partnership", partnershipMetrics.count)}
            {renderCardItem(directMetrics.revenue, "Direct", directMetrics.count)}
            {/* {renderCardItem(lostByBcdMetrics.revenue, `LOST By ${tmcName}`, lostByBcdMetrics.count)} */}
          </div>
        </Card>

      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>

        <Input
          placeholder="🔍 Search ..."
          style={{ width: 240, borderRadius: 8 }}
          allowClear

          onChange={handleSearch}
          disabled={!gridApiRef.current}
        />


        <div style={{ display: 'flex', gap: '12px' }}>
          <Button
            icon={<PlusOutlined />}
            style={{ backgroundColor: '#f0f5ff', color: '#1677ff' }}
            onClick={() => setIsAddRowModalOpen(true)}
          >
            Add New Row
          </Button>


          <Button
            icon={<DownloadOutlined />}
            onClick={handleExport}
            style={{ backgroundColor: '#f0f5ff', color: '#1677ff' }}
          >
            Export
          </Button>

          <Button
            icon={<ReloadOutlined />}
            onClick={reloadTable}
            style={{ backgroundColor: '#f0f5ff', color: '#1677ff' }}
          >
            Reload Table
          </Button>
        </div>
      </div>

      <div style={{ position: 'relative', height: "82vh", width: "100%" }}>
        <Spin
          spinning={loading}
          tip="Loading data..."
          size="large"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 10,
          }}
        />

        <div className="ag-theme-alpine" style={{ height: "100%", width: "100%", opacity: loading ? 0.3 : 1 }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true,
            }}
            onCellValueChanged={(params) => {
              // Skip if this is the PM Name field (handled by column-specific handler)
              if (params.colDef.field === "PM Name") {
                console.log("⏭️ Skipping global handler for PM Name field");
                return;
              }
              handleCellValueChanged(params);
            }}
            groupDisplayType="multipleColumns"
            singleClickEdit={true}
            stopEditingWhenCellsLoseFocus={true}
            onGridReady={(params) => {
              gridApiRef.current = params.api;
            }}
          />
        </div>
      </div>


      <Modal
        title="Edit Next Step"
        open={isModalOpen}
        onOk={handleModalSave}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>Cancel</Button>,
          <Button key="save" type="primary" onClick={handleModalSave}>Save</Button>
        ]}
      >
        <Input.TextArea
          rows={6}
          value={modalValue}
          onChange={(e) => setModalValue(e.target.value)}
        />
      </Modal>
      <Modal
        title="Add New Account Manager"
        open={isAddPmModalOpen}
        onCancel={() => setIsAddPmModalOpen(false)}
        centered
        footer={[
          <Button key="cancel" onClick={() => setIsAddPmModalOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            onClick={async () => {
              if (!newPmData.name || !newPmData.tmc) {
                return alert("Account Manager Name and TMC Name are required.");
              }

              const name = newPmData.name.trim();

              if (pmOptionsState.includes(name)) {
                alert("Account Manager already exists.");
                return;
              }

              try {
                // 1. Add to Accountmanagerdetails collection
                await fetch("https://bcd-prospect-admin.finkraftai.com/api/add-account-manager", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    name: newPmData.name,
                    email: newPmData.email,
                    contact: newPmData.contact,
                    tmc: newPmData.tmc
                  })
                });

                // 2. Update dropdown options
                const updated = [
                  ...pmOptionsState.filter(o => o !== "➕ Add New Account Manager..."),
                  name,
                  "➕ Add New Account Manager..."
                ];
                setPmOptionsState(updated);

                // 3. Update row in MongoDB via /api/update-tmc-details
                const email = localStorage.getItem("bcd_email");
                const rowId = editingRow?.data?._id;

                if (rowId) {
                  const updates = [
                    { field: "PM Name", value: newPmData.name },
                    { field: "PM Email ID", value: newPmData.email },
                    { field: "Contact", value: newPmData.contact }
                  ];

                  for (const { field, value } of updates) {
                    await fetch("https://bcd-prospect-admin.finkraftai.com/api/update-tmc-details", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        id: rowId,
                        source: newPmData.tmc,
                        updatedBy: email,
                        field,
                        value
                      })
                    });
                  }

                  // update frontend row data
                  editingRow.setDataValue("PM Name", newPmData.name);
                  editingRow.setDataValue("PM Email ID", newPmData.email);
                  editingRow.setDataValue("Contact", newPmData.contact);
                }

                // Clean up
                setNewPmData({ name: "", email: "", contact: "", tmc: tmcName });
                setIsAddPmModalOpen(false);
                setEditingRow(null);
              } catch (error) {
                console.error("Error saving Account Manager:", error);
                alert("Failed to save Account Manager. Please try again.");
              }
            }}

          >
            Save
          </Button>,
        ]}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label style={{ fontWeight: 500 }}>Account Manager Name<span style={{ color: 'red' }}> *</span></label>
            <Input
              placeholder="Enter Account Manager Name"
              value={newPmData.name}
              onChange={(e) => setNewPmData(prev => ({ ...prev, name: e.target.value }))}
            />
          </div>

          <div>
            <label style={{ fontWeight: 500 }}>Email ID</label>
            <Input
              placeholder="Enter Email ID"
              value={newPmData.email}
              onChange={(e) => setNewPmData(prev => ({ ...prev, email: e.target.value }))}
            />
          </div>

          <div>
            <label style={{ fontWeight: 500 }}>Contact</label>
            <Input
              placeholder="Enter Contact Number"
              value={newPmData.contact}
              onChange={(e) => setNewPmData(prev => ({ ...prev, contact: e.target.value }))}
            />
          </div>

          <div>
            <label style={{ fontWeight: 500 }}>TMC Name<span style={{ color: 'red' }}> *</span></label>
            <Input
              placeholder="Enter TMC Name"
              value={newPmData.tmc}
              onChange={(e) => setNewPmData(prev => ({ ...prev, tmc: e.target.value }))}
            />
          </div>
        </div>
      </Modal>
      <Modal
        title="Add New Row"
        open={isAddRowModalOpen}
        onCancel={() => setIsAddRowModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsAddRowModalOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={async () => {
              const rowPayload = {
                ...newRowData,
                SOURCE: tmcName,
                updatedBy: localStorage.getItem("bcd_email"),
                "Last activity": new Date().toISOString(),
              };

              try {
                const res = await fetch("https://bcd-prospect-admin.finkraftai.com/api/add-tmc-row", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(rowPayload),
                });

                const result = await res.json();

                if (res.ok) {
                  const commercial = parseFloat(newRowData["Commercial"] || 0);
                  const k3 = parseFloat(newRowData["Total K3"] || 0);
                  const newRow = {
                    ...newRowData,
                    source: tmcName,
                    "Potential Revenue": ((commercial * k3) / 100).toFixed(2),
                    _id: result.insertedId || Math.random().toString(36).substring(2, 9),
                  };

                  setRowData(prev => [...prev, newRow]);
                  setIsAddRowModalOpen(false);
                  setNewRowData({
                    "Workspace_Active11": "",
                    "Workspace-Trade_Name": "",
                    "Ticket_Number Count": "",
                    "Total K3": "",
                    "Commercial": "",
                    "Closing Date": "",
                  });
                } else {
                  alert("Failed to add row.");
                }
              } catch (err) {
                console.error("Error adding row", err);
                alert("Something went wrong.");
              }
            }}
          >
            Save
          </Button>
        ]}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div>
            <label>Client Type</label>
            <select
              style={{ width: "100%", padding: "8px" }}
              value={newRowData["Workspace_Active11"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Workspace_Active11": e.target.value }))}
            >
              <option value="">Select</option>
              {clientTypeOptions.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div>
            <label>Workspace</label>
            <Input
              placeholder="Enter Workspace"
              value={newRowData["Workspace-Trade_Name"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Workspace-Trade_Name": e.target.value }))}
            />
          </div>

          <div>
            <label>Transaction (Ticket Number Count)</label>
            <Input
              type="number"
              placeholder="Enter Ticket Count"
              value={newRowData["Ticket_Number Count"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Ticket_Number Count": e.target.value }))}
            />
          </div>
          <div>
            <label>PM Name</label>
            <Input
              placeholder="Enter Total K3"
              value={newRowData["PM Name"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "PM Name": e.target.value }))}
            />
          </div>

          <div>
            <label>Total K3</label>
            <Input
              type="number"
              placeholder="Enter Total K3"
              value={newRowData["Total K3"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Total K3": e.target.value }))}
            />
          </div>
          <div>
            <label>Contact</label>
            <Input
              placeholder="Enter Contact Name or Info"
              value={newRowData["Contact"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Contact": e.target.value }))}
            />
          </div>

          <div>
            <label>Next Step</label>
            <Input
              placeholder="Enter Next Step"
              value={newRowData["Next Step"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Next Step": e.target.value }))}
            />
          </div>

          <div>
            <label>PM Email ID</label>
            <Input
              placeholder="Enter PM Email"
              value={newRowData["PM Email ID"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "PM Email ID": e.target.value }))}
            />
          </div>


          <div>
            <label>Commercial %</label>
            <Input
              placeholder="Enter Commercial %"
              value={newRowData["Commercial"]}
              onChange={e => setNewRowData(prev => ({ ...prev, "Commercial": e.target.value }))}
            />
          </div>

          <div>
            <label>Closing Date</label>
            <DatePicker
              style={{ width: "100%" }}
              value={newRowData["Closing Date"] ? dayjs(newRowData["Closing Date"]) : null}
              onChange={(date, dateString) =>
                setNewRowData({ ...newRowData, "Closing Date": dateString })
              }
            />
          </div>

        </div>
      </Modal>
      <Modal
        open={showLogoutPopup}  // AntD v5 uses open instead of visible
        onOk={handleLogout}
        onCancel={() => setShowLogoutPopup(false)}
        centered
        closable={false} // hides default close icon
        footer={[
          <Button
            key="logout"
            type="primary"
            danger
            onClick={handleLogout}
            style={{ fontWeight: 'bold' }}
          >
            Yes, Logout
          </Button>,
          <Button
            key="cancel"
            onClick={() => setShowLogoutPopup(false)}
            style={{ fontWeight: 'bold' }}
          >
            No, Stay
          </Button>,
        ]}
      >
        <h2 style={{ fontSize: 20, color: '#333', marginBottom: 10 }}>
          Confirm Logout
        </h2>
        <p style={{ fontSize: 15, color: '#555' }}>
          Are you sure you want to log out of the portal?
        </p>
      </Modal>
      <Modal
        open={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        centered
        closable={false}
        footer={[
          <Button
            key="delete"
            type="primary"
            danger
            onClick={async () => {
              console.log(rowToDelete)
              const rowData = rowToDelete?.data;
              const api = rowToDelete?.api;

              try {
                const _id = rowData["_id"];
                const source = rowData["source"]; // ensure your row has a `source` field

                if (_id && source) {
                  // 🗑️ Call API to delete from DB
                  const response = await fetch("https://bcd-prospect-admin.finkraftai.com/api/delete-tmc-row", {
                    method: "DELETE",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: _id, source }),
                  });

                  const result = await response.json();

                  if (response.ok) {
                    // ✅ Remove from ag-grid
                    api.applyTransaction({ remove: [rowData] });

                    // 📝 Log the delete
                    const rowIdentifier =
                      rowData["Workspace-Trade_Name"] ||
                      rowData["Workspace"] ||
                      rowData["Client Name"] ||
                      rowData["PM Name"] ||
                      Object.entries(rowData).find(
                        ([key, val]) =>
                          key.toLowerCase().includes("name") &&
                          typeof val === "string" &&
                          val.trim() !== ""
                      )?.[1] ||
                      _id ||
                      "Unknown";

                    await fetch("https://bcd-prospect-admin.finkraftai.com/api/log-tmc-change", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        row: rowIdentifier,
                        column: "action",
                        oldValue: JSON.stringify(rowData),
                        newValue: "DELETED",
                        updatedBy: localStorage.getItem("bcd_email"),
                        timestamp: new Date().toISOString(),
                      }),
                    });

                    // 🎉 Cleanup
                    setShowDeleteModal(false);
                    setRowToDelete(null);
                  } else {
                    console.error("Delete failed:", result.error);
                    alert("Delete failed: " + result.error);
                  }
                } else {
                  alert("Missing _id or source in row data");
                }
              } catch (err) {
                console.error("Error deleting row:", err);
                alert("Error deleting row: " + err.message);
              }
            }}

            style={{ fontWeight: 'bold' }}
          >
            Yes, Delete
          </Button>,
          <Button
            key="cancel"
            onClick={() => setShowDeleteModal(false)}
            style={{ fontWeight: 'bold' }}
          >
            No, Cancel
          </Button>,
        ]}
      >
        <h2 style={{ fontSize: 20, color: '#333', marginBottom: 10 }}>
          Confirm Deletion
        </h2>
        <p style={{ fontSize: 15, color: '#555' }}>
          Are you sure you want to delete this row? This action cannot be undone.
        </p>
      </Modal>




    </div>
  );
};

export default TMCTable;
